export default "__VITE_ASSET__a43ce3d6__"